import { createStore, applyMiddleware, compose } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import { thunk } from "redux-thunk";
import rootReducer from "./reducers";

const initialState = {};
const middleware = [thunk];

const customComposeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25,
    })) ||
  compose;

const composedEnhancer =
  process.env.REACT_APP_VERSION === "local"
    ? customComposeEnhancers(
        // Add whatever middleware you actually want to use here
        applyMiddleware(...middleware)
        // other store enhancers if any)
      )
    : composeWithDevTools(
        // Add whatever middleware you actually want to use here
        applyMiddleware(...middleware)
        // other store enhancers if any
      );

const store = createStore(rootReducer, initialState, composedEnhancer);

export default store;
